/**
 *  Redirige vers l'espace fidelité v1 si client pas eligible aux défis
 */
import { useClientStore } from "@/store/client";

export default defineNuxtRouteMiddleware((route) => {

  const { $pinia } = useNuxtApp();
  const clientStore = useClientStore($pinia);

  if (!clientStore.isEligibleDefis) {
    return navigateTo("/mon-compte/ma-fidelite", { query: route.query, replace: true, redirectCode: 302 });
  }

  return;
})
